<template>
  <Modal appear @close="close">
    <template slot="content">
      <div class="p-config-management-form">
        <div class="p-config-management-form__content c-text--center">
          <h3 class="p-config-management-form__title">
            招待状のメールを<br />ご指定のユーザーに再送信いたしました。
          </h3>
          <img
            src="@/assets/img/img-register-provisional.gif"
            alt=""
            width="100"
            height="200"
          />
        </div>
        <div class="p-config-management-form__footer">
          <Button variant="main" size="w230" fsize="f16" @click="close">
            一覧に戻る
          </Button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Button from '@/components/Button';
import Modal from '@/components/Modal';

export default {
  components: {
    Button,
    Modal
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>
